import React, { useEffect, useState } from 'react'
import useMakeRequest from '../utils/ApiHelper'
import { ApiConstants } from '../constants/ApiConstants'
import FrontLoader from '../component/layout/FrontLoader'
import { useNavigate } from 'react-router-dom'
import { LanguageConstants } from '../constants/LanguageConstants'

function QuotationEdit(props:any) {
    const [quantity , setQuantity] = useState<any>('')
    const navigate = useNavigate()
    const [error , setError] = useState('')
    const Reply = useMakeRequest()
    const handelSubmit =()=>{
        const numberRegex = /^[0-9]+$/;
        if(!quantity){
          return  setError(LanguageConstants?.ENTER_TIME_QUNTITY)
        }
        if(quantity <= 0){
          return  setError(LanguageConstants?.QUNTITY_MIN)
        }
        if(!numberRegex.test(quantity)){
           setError(LanguageConstants?.ENTER_TIME_QUNTITY_NUMBER)
        }else{
            props?.setQuotesEdit(true)
            setError('')
            props.handleClose()
        }
    }

    useEffect(()=>{
    if(Reply?.status){
    props.handleClose()
    navigate('/my-quotation')
    window.location.reload()
     }
    },[Reply?.status])


    const handleInputEdit = (value: any) => {
        const id = props?.data?.id
        setQuantity(value)
        if (/^[1-9]\d{0,3}$/.test(value) && Number(value) <= 10000) {
            // if (value) {
            //     props?.setQuotesEdit(true)
            // } else {
            //     props?.setQuotesEdit(false)
            // }
            const updatedQuotes = props?.quotes?.map((quote: any) =>
                quote.quote_id == id
                    ? { ...quote, quantity: value , s_no:props?.s_no }
                    : quote
            );
            props?.setQuotes(updatedQuotes)
        } else {
            props?.setQuotesEdit(false)
        }
    };

  return (
    <>
    {Reply.loading ? <FrontLoader/> : null}
    <div className="modal fade com-modal short-modal show" id="editQuantityModal" aria-labelledby="editQuantityModalLabel" aria-hidden="false"  style={{display: "block"}} >
                <div className="modal-dialog modal-dialog-centered">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title" id="editQuantityModalLabel">{LanguageConstants?.EDIT_QUANTITY}</h5>
                            <button type="button" onClick={()=>props.handleClose()} className="btn-close" data-bs-dismiss="modal" aria-label="Close"><i className="icon-close-square" /></button>
                        </div>
                        <div className="modal-body pb-0 text-start">
                            <div className="com-input-wrap mb-3">
                                <label className="form-label">{LanguageConstants?.QUANTITY}</label>
                                <input type="text" className="form-control" onChange={(e:any)=>handleInputEdit(e?.target?.value)} />
                            </div>
                            <p className='text-error-new'>{error}</p>
                        </div>
                        <div className="modal-footer"> 
                            <button onClick={()=>handelSubmit()} className="round-btn m-0 w-100" >{LanguageConstants?.UPDATE}</button>
                        </div>
                    </div>
                </div>
     </div>
    </>
  )
}

export default QuotationEdit